export default __webpack_public_path__ + "static/media/Smart_Daily_Demo.4b491047.mp4";